import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const shopifyApi = createApi({
  reducerPath: "shopifyApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    // Get connected Shopify store
    getConnectedStore: builder.query({
      query: () => "shopify/store",
      providesTags: ["ShopifyStore"],
    }),

    // Initiate OAuth flow
    initiateShopifyOAuth: builder.mutation({
      query: (shopDomain) => ({
        url: "shopify/auth/initiate",
        method: "POST",
        body: { shopDomain },
      }),
    }),

    // Handle OAuth callback
    handleShopifyCallback: builder.mutation({
      query: ({ code, shop, userId }) => ({
        url: "shopify/auth/callback",
        method: "POST",
        body: { code, shop, userId },
      }),
      invalidatesTags: ["ShopifyStore"],
    }),

    // Disconnect Shopify store
    disconnectShopify: builder.mutation({
      query: () => ({
        url: "shopify/store",
        method: "DELETE",
      }),
      invalidatesTags: ["ShopifyStore"],
    }),

    // Get products from Shopify
    getShopifyProducts: builder.query({
      query: () => "shopify/products",
      providesTags: ["ShopifyProducts"],
    }),

    // Post product to Shopify
    postProductToShopify: builder.mutation({
      query: (product) => ({
        url: "shopify/products",
        method: "POST",
        body: { product },
      }),
      invalidatesTags: ["ShopifyProducts"],
    }),

    // Bulk post products to Shopify
    bulkPostProductsToShopify: builder.mutation({
      query: (products) => ({
        url: "shopify/products/bulk",
        method: "POST",
        body: { products },
      }),
      invalidatesTags: ["ShopifyProducts"],
    }),

    // Import products from Shopify
    importProductsFromShopify: builder.mutation({
      query: () => ({
        url: "shopify/products/import",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetConnectedStoreQuery,
  useInitiateShopifyOAuthMutation,
  useHandleShopifyCallbackMutation,
  useDisconnectShopifyMutation,
  useGetShopifyProductsQuery,
  usePostProductToShopifyMutation,
  useBulkPostProductsToShopifyMutation,
  useImportProductsFromShopifyMutation,
} = shopifyApi;
